export default "__VITE_ASSET__428d48cd__"